import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";

export default GrComponentFactory.createClass({
  displayName: "GeneralStatusNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      user: GrPropTypes.user().isRequired,
      userStatusText: React.PropTypes.string.isRequired,
    }).isRequired,
  },

  getUserStatusText() {
    return {
      __html: this.props.resource.userStatusText,
    };
  },

  render() {
    const body = <div className="gr-newsfeedItem__generalStatusText"
                    dangerouslySetInnerHTML={this.getUserStatusText()} />;
    return <SocialUpdate body={body} {...this.props}/>;
  },
});
